import { F as e, h as t, t as n, v as r } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/webcomponents/common/Loading.ce.vue?vue&type=style&index=0&inline&lang.scss
var i = ".loader{aspect-ratio:1;border-radius:50%;width:8px;animation:1s linear infinite alternate l5;transform:translate(100%)}.sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}@keyframes l5{0%{background:#000;box-shadow:13px 0 #000,-13px 0 #0002}33%{background:#0002;box-shadow:13px 0 #000,-13px 0 #0002}66%{background:#0002;box-shadow:13px 0 #0002,-13px 0 #000}to{background:#000;box-shadow:13px 0 #0002,-13px 0 #000}}@media (prefers-reduced-motion:reduce){.loader{display:none}}", a = {}, o = {
	class: "loader",
	role: "alert"
};
function s(n, i) {
	return e(), r("div", o, [...i[0] ||= [t("p", { class: "sr-only" }, " Chargement... ", -1)]]);
}
var c = /*#__PURE__*/ n(a, [["render", s], ["styles", [i]]]);
//#endregion
export { c as t };
